import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'ctm-components';
import { pageContext } from 'ctm-util-functions';
import { useStyles } from './prefill_styles';

const PrefillQuoteCTAButtons = (props) => {
    const { continueDisabled, continueNewQuote, resumeQuoteFunc } = props;
    const vertical = pageContext.getVertical();

    const classes = useStyles({ vertical });

    return (
        <div className={classes.quoteButtonWrapper}>
            <Button
                id="prefillVerify.resumeQuoteButton"
                icon="ctm_arrow_right"
                UIComponent={continueDisabled
                    ? 'btn_secondary_xlarge_semi_rounded_disabled'
                    : 'btn_secondary_xlarge_semi_rounded'}
                onClickFunction={resumeQuoteFunc}
                variant="full_width"
                label="Retrieve my quote"
            />
            <p className={classes.subtext}>
                Want to start over? No problem,
                {' '}
                <Button tagName={'a'} className={classes.linkText} onClickFunction={continueNewQuote}>
                    continue with your new quote
                </Button>
            </p>
        </div>
    );
};

PrefillQuoteCTAButtons.propTypes = {
    continueDisabled: PropTypes.bool.isRequired,
    continueNewQuote: PropTypes.func.isRequired,
    resumeQuoteFunc: PropTypes.func.isRequired
};

export { PrefillQuoteCTAButtons };
